/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";
import {
    Card,
    CardBody,
    CardHeader
} from "reactstrap";
import Loader from "../../Components/Common/Loader";
import ForeCastPreviewCardHeader from "../../Components/Common/ForeCastPreviewCardHeader";
import { ForeCastCover } from "./FlashCharts";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { FLASH } from "../../helpers/data_helper";

const ForeCastCovers = ({ mealPeriod, leftFilter }) => {
    const [forecastAjax, setForecastAjax] = useState(false);
    const [start_dt, setstart_dt] = useState("");
    const [end_dt, setend_dt] = useState("");
    const [forecastData, setForecastData] = useState({
        covers: [],
        average_check: [],
        revPASH: []
    });

    let date = new Date();
    date.setDate(date.getDate() - 1);

    let date_second = new Date();
    date_second.setDate(date_second.getDate() - 1);

    useEffect(() => {

        // console.log("Selected Meal Period:", mealPeriod);
        // console.log("Selected Date:", leftFilter);
        const controller = new AbortController();
        setForecastAjax(true);
        postDataAPI({
            serviceName: FLASH.serviceName,
            op: FLASH.op_rev_forecast,
            leftFilter: leftFilter,
            mealPeriod: mealPeriod
        }, controller.signal).then((response) => {
            setForecastAjax(false);
            if (response.status === "ok") {
                setForecastData({
                    covers: response.data.data.covers || [],
                    average_check: response.data.data.average_check || [],
                    revPASH: response.data.data.revPASH || []
                });
                setstart_dt(response.data.data.start_dt);
                setend_dt(response.data.data.end_dt);
            } else {
                // console.log(response);
            }
        });
        return () => {
            controller.abort();
        };

    }, [mealPeriod, leftFilter]);

    return (
        <React.Fragment>
            <Card>
                <ForeCastPreviewCardHeader
                    title={<div className="d-flex align-items-start">
                        <div className={`icon-box rounded bg-danger text-white`}>
                            <i className="ri-bar-chart-fill"></i>
                        </div>
                        <div className="ps-2">
                            <h4 className="card-title mb-1">
                                Actual / Forecast – Covers, Average Check and Revenue
                            </h4>
                            <p className="text-muted mb-0">
                                Daily Covers, Average Check and Revenue for the month – Actual and Forecasted
                            </p>
                        </div>
                    </div>}
                    toggleText="Show Table"
                />
                <CardBody>
                    {forecastAjax && <Loader />}
                    <div id="ForeCastCovers" className={forecastAjax ? "opacity-0" : ""}>
                        <div className="live-preview">
                            <ForeCastCover
                                forecastData={forecastData}
                                dataColors='["--vz-primary", "--vz-danger", "--vz-success", "--vz-warning", "--vz-info", "--vz-dark"]'
                                start_dt={start_dt}
                                end_dt={end_dt}
                            />
                        </div>
                        <div className="d-none code-view">
                            <div className="table-responsive table-card">
                                <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                                    <thead className="text-muted table-light">
                                        <tr>
                                            <th scope="col">Period</th>
                                            <th scope="col">Covers</th>
                                            <th scope="col">Avg Checks</th>
                                            <th scope="col">RevPash</th>
                                        </tr>
                                    </thead>
                                    <tbody>
  {(forecastData.covers || []).map((item, key) => {
    const baseDate = new Date(start_dt);
    baseDate.setDate(baseDate.getDate() + key);

    return (
      <tr key={key}>
        <td>
          {baseDate.toLocaleString("en-us", { day: "2-digit" }) +
            " " +
            baseDate.toLocaleString("en-us", { month: "short" })}
        </td>
        <td>{item}</td>
        <td>{forecastData.average_check[key] ?? ""}</td>
        <td>{forecastData.revPASH[key] ?? ""}</td>
      </tr>
    );
  })}
</tbody>

                                </table>
                            </div>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </React.Fragment>
    );
};

export default ForeCastCovers;
